import { apiUrl } from '../../config.json';
import axios from 'axios'
import auth from './authService'

const apiEndPoint = apiUrl
const token = localStorage.getItem('authToken')
axios.interceptors.request.use(
    config => {
        config.headers.authorization = `Bearer ${token}`;
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

export async function getAllUsers() {
    let response = await axios.get(apiEndPoint + "/users")
    return await response.data
}
export async function logout() {
    let response = await axios.post(apiEndPoint + "/auth/logout")
    auth.logout()
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUser");
    window.location = "/"
    return response.data
}
export async function getAllUsersGroups() {
    let response = await axios.get(apiEndPoint + "/groups")
    return await response.data
}
export async function addNewUser(newUser) {
    return axios.post(apiEndPoint + "/users/create", newUser)
}
export default {
    getAllUsers,
    getAllUsersGroups,
    addNewUser,
    logout
}